import { Box, IconButton, Typography } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import MainContainer from '@ecm/ui/element/MainContainer'

import playIcon from '/public/images/icon/play.svg'

type HeroProps = {
  children: React.ReactNode
  heading: string
  image: string
  onClickVideoButton?: (value: boolean) => void
}

const Hero = ({ image, heading, children, onClickVideoButton }: HeroProps) => (
  <MainContainer sx={{ paddingY: '64px' }}>
    <Box
      display="grid"
      gap={{ lg: '0px', md: '70px', xl: '100px', xs: '30px' }}
      alignItems="center"
      gridTemplateColumns={{
        md: '1fr 1fr',
        xs: '1fr',
      }}
    >
      <Box>
        <Typography
          variant="h2"
          component="h1"
          sx={{
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundImage: 'linear-gradient(272.81deg, #4EDF97 11.53%, #0F2272 100%)',
          }}
        >
          {heading}
        </Typography>

        {children}
      </Box>
      <Box justifySelf="center" position="relative">
        <CloudflareImage src={image} />
        {onClickVideoButton && (
          <IconButton
            onClick={() => onClickVideoButton(true)}
            sx={{
              '& img': { transition: '0.3s ease-in-out' },
              '& img:hover': { opacity: 0.7 },
              left: '31%',
              position: 'absolute',
              top: '40%',
              width: { lg: 'unset', md: '90px', sm: 'unset', xs: '70px' },
            }}
          >
            <CloudflareImage src={playIcon} />
          </IconButton>
        )}
      </Box>
    </Box>
  </MainContainer>
)

export default Hero
